export const NOTIF_STYLES = {
  critical: {
    border: "border-red-500/30",
    bg: "bg-red-900/15",
    iconBg: "bg-red-900/30 border border-red-500/30",
    iconColor: "text-red-300",
    chipBg: "bg-red-500/20",
    chipText: "text-red-300",
    chipLabel: "Critical",
  },
  warning: {
    border: "border-amber-500/30",
    bg: "bg-amber-900/10",
    iconBg: "bg-amber-900/20 border border-amber-500/30",
    iconColor: "text-amber-300",
    chipBg: "bg-amber-500/20",
    chipText: "text-amber-300",
    chipLabel: "Warning",
  },
  info: {
    border: "border-brand-magenta/30",
    bg: "bg-brand-magenta/5",
    iconBg: "bg-brand-magenta/10 border border-brand-magenta/30",
    iconColor: "text-brand-magenta",
    chipBg: "bg-brand-magenta/15",
    chipText: "text-brand-magenta",
    chipLabel: "Info",
  },
};
